import { Skeleton } from 'antd'
import React, { FunctionComponent, memo } from 'react'

interface SkeletonConfig {
  width?: string
  paragraphWidths: string | string[]
}

function generateWidths(rows: number): string[] {
  return Array.from(
    { length: rows },
    () => `${Math.floor(Math.random() * 50) + 50}%`
  )
}

const skeletonConfigs: SkeletonConfig[] = [
  { width: '35%', paragraphWidths: '100%' },
  { width: '75%', paragraphWidths: generateWidths(25) },
  { paragraphWidths: generateWidths(25) },
  { paragraphWidths: generateWidths(25) },
  { width: '75%', paragraphWidths: generateWidths(25) },
  { paragraphWidths: generateWidths(25) },
  { width: '35%', paragraphWidths: '100%' },
  { width: '35%', paragraphWidths: '100%' },
]

export interface TableSkeletonProps {
  rows?: number
}

export const TableSkeleton: FunctionComponent<TableSkeletonProps> = memo(
  ({ rows = 25 }) => (
    <div className="flex space-x-8">
      {skeletonConfigs.map((cfg, index) => (
        <Skeleton
          key={index}
          active
          title={{ width: '100%' }}
          style={cfg.width ? { width: cfg.width } : undefined}
          paragraph={{
            rows,
            width: cfg.paragraphWidths,
          }}
          className="mt-4"
        />
      ))}
    </div>
  )
)
